function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeWidth: 3
}, React.createElement("path", {
  d: "M15.365 2H25M25 12V2",
  strokeLinecap: "square"
}), React.createElement("path", {
  d: "M24 3L9.019 17.944M9 4.54H1.548v20.963h20.989V18"
}));

function SvgIconExternal(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 27 27"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjcgMjciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxIDEpIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4KSI+PHBhdGggZD0ibTYuMzY0OTkwMjMgMWg5LjYzNTAwOTc3IiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+PHBhdGggZD0ibTExIDZoMTAiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIHRyYW5zZm9ybT0ibWF0cml4KDAgLTEgMSAwIDEwIDIyKSIvPjxwYXRoIGQ9Im0xNSAyLTE0Ljk4MTQ0NTMxIDE0Ljk0NDMzNTkiLz48L2c+PHBhdGggZD0ibTggMy41Mzk1NTA3OGgtNy40NTIxNDg0NHYyMC45NjMxMzQ3MmgyMC45ODg4OTE2NHYtNy41MDI2ODU1Ii8+PC9nPjwvc3ZnPgo=";
export { SvgIconExternal as ReactComponent };